import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewStoreLocator from '@/views/view-store-locator';

import '../../styles/pages/store-locator.scss';

whenDomReady(() => {
    new ViewStoreLocator({el: $('#MainContent')});
});